"use client";

import { GlowCard } from "./animations";
import type { Agent } from "@/lib/agent-roster";

const STATUS_DOT: Record<Agent["status"], string> = {
  shipping: "bg-accent",
  beta:     "bg-foreground/60",
  soon:     "bg-foreground/30",
};

const STATUS_LABEL: Record<Agent["status"], string> = {
  shipping: "Shipping",
  beta:     "Beta",
  soon:     "Soon",
};

export function AgentCard({ agent, index }: { agent: Agent; index: number }) {
  return (
    <GlowCard
      glow={200}
      className="lift-card group h-full rounded-2xl border hairline-strong p-6 md:p-7 bg-background relative"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <span className="font-mono text-[10px] text-foreground/65 tabular-num shrink-0">
            {String(index + 1).padStart(2, "0")}
          </span>
          <h3 className="display-serif text-xl md:text-[1.35rem] leading-tight truncate">
            {agent.name}
          </h3>
        </div>
        <span className="inline-flex items-center gap-1.5 shrink-0 rounded-full border hairline px-2 py-0.5 text-[10px] font-mono uppercase tracking-[0.14em] text-foreground/65">
          <span className={`inline-block h-1.5 w-1.5 rounded-full ${STATUS_DOT[agent.status]}`} />
          {STATUS_LABEL[agent.status]}
        </span>
      </div>
      <p className="mt-3 text-sm text-foreground/70 leading-relaxed">
        {agent.description}
      </p>
    </GlowCard>
  );
}
